import React, { useState, useMemo, useCallback } from 'react';
import './portfolio.css';
import Menu from '../../components/menu/menu';
import ModalPortfolio from '../../components/modal-portfolio/modal-portfolio';

// Imagens dos projetos
import Pokedex from "../../assets/imgs/projects/img-project-pokedex.png";
import Construcao from "../../assets/imgs/projects/img_em_construcao.png";
import StyleBarber from "../../assets/imgs/projects/styleBarber.png";
import LeoSoft from "../../assets/imgs/projects/leosoft.png";
import LeoBook from "../../assets/imgs/projects/leobook.png";
import GameVault from "../../assets/imgs/projects/gamevault.png";



// Ícones
import { FiGithub, FiExternalLink, FiEye } from "react-icons/fi";

/**
 * Dados dos projetos organizados por tecnologia
 */
const PROJECTS_DATA = {
  "Vue.js": [
    {
      id: 1,
      name: "Barber Style",
      description: "Plataforma de agendamento para barbearia com interface moderna",
      image: StyleBarber,
      technologies: ["Vue.js", "Nuxt.js", "Tailwind CSS"],
      github: "https://github.com/Leonardu76/stylusBarber",
      website: "https://kaleidoscopic-brigadeiros-300feb.netlify.app/",
      year: 2023,
      role: "Desenvolvedor Full Stack"
    },
    {
      id: 2,
      name: "Leo Soft",
      description: "Sistema de gestão empresarial com dashboard completo",
      image: LeoSoft,
      technologies: ["Vue.js", "Nuxt.js", "Ant Design Vue"],
      github: null,
      website: "https://leosoft.netlify.app/",
      year: 2023,
      role: "Desenvolvedor Full Stack"
    },
    {
      id: 3,
      name: "Leo Book",
      description: "Biblioteca digital para gerenciamento de livros e leitura",
      image: LeoBook,
      technologies: ["Vue.js", "Quasar", "TypeScript"],
      github: null,
      website: "https://books.leonardoliveiras.com.br/#/",
      year: 2025,
      role: "Desenvolvedor Full Stack"
    }
  ],
  "React.js": [
    {
      id: 4,
      name: "Pokédex",
      description: "Aplicação interativa para consultar dados de Pokémons",
      image: Pokedex,
      technologies: ["React.js", "Fetch API", "Styled Components"],
      github: "https://github.com/Leonardu76/Pokedex-React",
      website: "https://dapper-pie-836bf4.netlify.app/",
      year: 2023,
      role: "Desenvolvedor Frontend"
    }
  ],
  "PHP": [
    {
      id: 5,
      name: "Game Vault",
      description: "Game Vault é um site desenvolvido em PHP puro (vanilla) que permite aos usuários criarem uma conta e acessarem uma área exclusiva através de login seguro.",
      image: GameVault,
      technologies: ["PHP", "jQuery","AJAX",  "MySQL"],
      github: null,
      website: "https://www.gamevault.leonardoliveiras.com.br",
      year: 2026,
      role: "Desenvolvedor Full Stack",
    },
    {
      id: 6,
      name: "Finance Manager API",
      description: "Em desenvolvimento: API RESTful para gerenciamento financeiro pessoal, com autenticação JWT e integração com bancos de dados MySQL.",
      image: Construcao,
      technologies: ["PHP", "Laravel", "MySQL"],
      github: null,
      website: null,
      year: 2026,
      role: "Desenvolvedor Laravel",
      status: "em_desenvolvimento"
    }
  ]
};

/**
 * Componente Card de Projeto
 */
const ProjectCard = ({ project, onViewDetails }) => {
  const isComingSoon = project.status === "em_desenvolvimento";

  return (
    <article className="project-card" data-project-id={project.id}>
      {/* Imagem do Projeto */}
      <div className="project-image-wrapper">
        <img
          src={project.image}
          alt={project.name}
          className="project-image"
          loading="lazy"
        />

        {/* Badge de Status */}
        {isComingSoon && (
          <div className="project-badge project-badge-coming">
            Em Desenvolvimento
          </div>
        )}
      </div>

      {/* Conteúdo do Card */}
      <div className="project-content">
        <h3 className="project-title">{project.name}</h3>
        <p className="project-description">{project.description}</p>

        {/* Tecnologias */}
        <div className="project-technologies">
          {project.technologies.map((tech, idx) => (
            <span key={idx} className="tech-badge">
              {tech}
            </span>
          ))}
        </div>

        {/* Botões de Ação */}
        <div className="project-actions">
          <button
            type="button"
            className="btn-project btn-project-primary"
            onClick={() => onViewDetails(project)}
            disabled={isComingSoon}
            aria-label={`Ver detalhes do projeto ${project.name}`}
          >
            <FiEye className="btn-icon" />
            Detalhes
          </button>

          {project.website && (
            <a
              href={project.website}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-project btn-project-secondary"
              aria-label={`Abrir site do projeto ${project.name}`}
            >
              <FiExternalLink className="btn-icon" />
              Site
            </a>
          )}

          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-project btn-project-secondary"
              aria-label={`Abrir repositório GitHub do projeto ${project.name}`}
            >
              <FiGithub className="btn-icon" />
              GitHub
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

/**
 * Componente Principal - Portfolio
 */
function Portfolio() {
  const [activeCategory, setActiveCategory] = useState("Todos");
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Calcular todos os projetos
  const allProjects = useMemo(() => {
    return Object.values(PROJECTS_DATA).flat();
  }, []);

  // Filtrar projetos por categoria
  const filteredProjects = useMemo(() => {
    if (activeCategory === "Todos") {
      return allProjects;
    }
    return PROJECTS_DATA[activeCategory] || [];
  }, [activeCategory, allProjects]);

  // Manipulador de clique em categoria
  const handleCategoryChange = useCallback((category) => {
    setActiveCategory(category);
  }, []);

  // Manipulador para ver detalhes do projeto
  const handleViewDetails = useCallback((project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  }, []);

  // Manipulador para fechar modal
  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  }, []);

  return (
    <>
      <Menu url="portfolio" />

      <main className="portfolio-page">
        <div className="portfolio-container">
          {/* Header */}
          <section className="portfolio-header">
            <h1 className="portfolio-title">
              <span className="portfolio-emoji">🚀</span>
              Meus Projetos
            </h1>
            <p className="portfolio-subtitle">
              Conheça os projetos que desenvolvi utilizando as melhores tecnologias
            </p>
            <div className="title-divider"></div>
          </section>

          {/* Filtros/Categorias */}
          <div className="portfolio-filters">
            {["Todos", "Vue.js", "React.js", "PHP"].map((category) => (
              <button
                key={category}
                className={`filter-btn ${activeCategory === category ? "active" : ""}`}
                onClick={() => handleCategoryChange(category)}
                aria-pressed={activeCategory === category}
                aria-label={`Filtrar por ${category}`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Grid de Projetos */}
          {filteredProjects.length > 0 ? (
            <div className="projects-grid">
              {filteredProjects.map((project) => (
                <ProjectCard
                  key={project.id}
                  project={project}
                  onViewDetails={handleViewDetails}
                />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">📭</div>
              <p className="empty-state-text">
                Nenhum projeto encontrado nesta categoria
              </p>
            </div>
          )}
        </div>
      </main>

      {/* Modal de Detalhes */}
      {selectedProject && (
        <ModalPortfolio
          project={selectedProject}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}

export default Portfolio;
